import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    InvitedListQuery,
    InvitedListQueryVariables,
} from './Invited.queries.generated'

export const GET_INVITED_LIST: TypedDocumentNode<
    InvitedListQuery,
    InvitedListQueryVariables
> = gql`
    query InvitedList($guid: String!, $limit: Int!, $offset: Int, $q: String) {
        entity(guid: $guid) {
            guid
            ... on Event {
                attendees(
                    limit: $limit
                    offset: $offset
                    query: $q
                    orderBy: timeUpdated
                    orderDirection: desc
                    isInvited: true
                    state: "unconfirmed"
                ) {
                    total
                    edges {
                        guid
                        icon
                        url
                        name
                        email
                    }
                }
            }
        }
    }
`
